import { connect } from 'react-redux';
import { isVideoCaptureEnabledSelector } from '../../../../../../store/redux/selectors/videoCaptureEnabledSelector';

import OpenTextOptions from './OpenTextOptions';
export default connect(isVideoCaptureEnabledSelector)(OpenTextOptions);
